// Header.js
import "./Header.css";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Modal, Offcanvas } from "react-bootstrap";
import { FiChevronDown, FiClock, FiGitCommit } from "react-icons/fi";

import hLines from "../../static/h_lines.png";
import Brand from "../../static/brand.png";

import Indice from "./Indice";
import Usuario from "./Usuario";
import useFetchAppVersion from "../0. Utilidades/useFetchAppVersion"; // Import the custom hook

function Header() {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showVersions, setShowVersions] = useState(false);
  const { version: appVersion, versions, loading: versionsLoading } = useFetchAppVersion();

  const handleOffcanvasToggle = () => {
    setShowOffcanvas(!showOffcanvas);
  };

  return (
    <div id="Header">
      <div className="header-container">
        <div id="h_left">
          <img
            src={hLines}
            className="b_indice"
            alt="Logo"
            loading="eager"
            onClick={handleOffcanvasToggle}
            style={{ cursor: "pointer" }}
          />
          <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
            <img src={Brand} alt="Logo" loading="eager" />
          </Link>
        </div>
        <Usuario />
        <Offcanvas
          show={showOffcanvas}
          onHide={handleOffcanvasToggle}
          placement="start"
          className="app-navigation-drawer"
        >
          <Offcanvas.Header closeButton className="app-navigation-header">
            <Offcanvas.Title className="app-navigation-title">
              <span className="app-navigation-eyebrow">RedMaestra Intranet</span>
              <strong>Menú principal</strong>
              <button
                type="button"
                className="app-navigation-version"
                title="Ver las últimas versiones"
                onClick={() => setShowVersions(true)}
                disabled={versionsLoading}
              >
                <span>Versión: {appVersion}</span>
                <FiChevronDown aria-hidden="true" />
              </button>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body className="app-navigation-body">
            <Indice handleOffcanvasToggle={handleOffcanvasToggle} />
          </Offcanvas.Body>
        </Offcanvas>
        <Modal show={showVersions} onHide={() => setShowVersions(false)} centered scrollable className="version-history-modal">
          <Modal.Header closeButton>
            <div>
              <span className="version-history-eyebrow">RedMaestra Intranet</span>
              <Modal.Title>Últimas versiones</Modal.Title>
            </div>
          </Modal.Header>
          <Modal.Body>
            {versions.length ? (
              <ol className="version-history-list">
                {versions.slice(0, 10).map((item, index) => (
                  <li className={index === 0 ? "is-current" : ""} key={`${item.commit}-${item.date}-${index}`}>
                    <span className="version-history-number">{String(index + 1).padStart(2, "0")}</span>
                    <div>
                      <div className="version-history-title">
                        <strong>{item.title}</strong>
                        {index === 0 && <span>Actual</span>}
                      </div>
                      <small>
                        {item.date && <span><FiClock /> {item.date}</span>}
                        {item.commit && <span><FiGitCommit /> {item.commit}</span>}
                      </small>
                    </div>
                  </li>
                ))}
              </ol>
            ) : (
              <p className="version-history-empty">El historial de versiones no está disponible.</p>
            )}
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}

export default Header;
